var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-level',[_c('g-level-item',[_c('g-typography',{attrs:{"value":_vm.title,"font-weight":"semibold","text-overflow":"ellipsis"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }